module.exports = __webpack_public_path__ + "static/media/user-defined-gears.2692f53d.svg";